import { useCallback, useContext } from "react";
import { PspTextAreaProps } from "./pspTextArea.types";
import { PspContext } from "@/config/contexts";
import { Field, Text, Textarea, useId } from "@fluentui/react-components";
import { translate } from "@/config/translator";
import { clsx } from "clsx/lite";

export function PspTextArea({
  onChange,
  value,
  label,
  className,
  showRequiredWarning,
  ref,
  placeholder,
  onKeyDown,
  onFocus,
  onBlur,
  rows,
  disabled,
  labelString,
}: PspTextAreaProps) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const { lang } = useContext(PspContext);

  // -----------------------------------------------------------------------------
  // IDS
  // -----------------------------------------------------------------------------
  const inputId = useId();

  // -----------------------------------------------------------------------------
  // CALLBACK FUNCTIONS
  // -----------------------------------------------------------------------------
  const onChangeWrapper: React.ChangeEventHandler<HTMLTextAreaElement> =
    useCallback(
      (event) => {
        onChange(event.target.value);
      },
      [onChange],
    );

  return (
    <Field className="flex flex-col gap-2 group">
      <div className="flex flex-row gap-4 items-center">
        <label
          htmlFor={inputId}
          className={clsx(
            !disabled && "group-focus-within:text-font-black",
            "text-font-secondary",
            "duration-200",
            "ease-in-out",
          )}
        >
          {label ? translate(label, lang) : labelString}
        </label>
        {showRequiredWarning && !value.trim() && (
          <Text size={200} className="text-warning">
            {translate("fieldRequired", lang)}
          </Text>
        )}
      </div>
      <Textarea
        className={className}
        rows={rows}
        disabled={disabled}
        placeholder={placeholder ? translate(placeholder, lang) : undefined}
        id={inputId}
        onChange={onChangeWrapper}
        value={value}
      />
    </Field>
  );
}
